// import React, { useState, useRef } from "react";

// function TestDropdown({ testList, onTestSelect }) {
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [search, setSearch] = useState("");
//   const inputRef = useRef(null);

//   // Filter and sort: matched first, then others
//   const filteredList = testList
//     .filter((test) =>
//       test.service_name.toLowerCase().includes(search.toLowerCase())
//     )
//     .sort((a, b) => {
//       const aMatch = a.service_name.toLowerCase().startsWith(search.toLowerCase());
//       const bMatch = b.service_name.toLowerCase().startsWith(search.toLowerCase());
//       if (aMatch && !bMatch) return -1;
//       if (!aMatch && bMatch) return 1;
//       return 0;
//     });

//   return (
//     <div style={{ position: "relative" }}>
//       <input
//         ref={inputRef}
//         onFocus={() => setShowDropdown(true)}
//         onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
//         placeholder="Select test"
//         value={search}
//         onChange={e => setSearch(e.target.value)}
        
//       />
//       {showDropdown && (
//         <ul
//           style={{
//             position: "absolute",
//             top: "100%",
//             left: 0,
//             right: 0,
//             background: "#fff",
//             border: "1px solid #ccc",
//             zIndex: 10,
//             maxHeight: 200,
//             overflowY: "auto",
//             margin: 0,
//             padding: 0,
//             listStyle: "none",
//           }}
//         >
//           {filteredList.map((test, idx) => (
//             <li
//               key={test.id || idx}
//               style={{ padding: "8px", cursor: "pointer" }}
//               onMouseDown={() => {
//                 setSearch(test.service_name);
//                 setShowDropdown(false);
//                 if (onTestSelect) onTestSelect(test.service_name);
//               }}
//             >
//               {test.service_name}
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// }
// export default TestDropdown;


import React, { useState, useRef } from "react";
import { Chip, Box } from "@mui/material";

function TestDropdown({ testList, onTestSelect, selectedTests, onDeleteTest }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [search, setSearch] = useState("");
  const inputRef = useRef(null);

  // Filter and sort: matched first, then others
  const filteredList = testList
    .filter(
      (test) =>
        test.service_name.toLowerCase().includes(search.toLowerCase()) &&
        !(selectedTests || []).includes(test.service_name) // prevent already-selected
    )
    .sort((a, b) => {
      const aMatch = a.service_name.toLowerCase().startsWith(search.toLowerCase());
      const bMatch = b.service_name.toLowerCase().startsWith(search.toLowerCase());
      if (aMatch && !bMatch) return -1;
      if (!aMatch && bMatch) return 1;
      return 0;
    });

  const handleSelect = (serviceName) => {
    if (onTestSelect) onTestSelect(serviceName);
    setSearch("");
    setShowDropdown(false);
  };

  return (
    <div style={{ position: "relative" }}>
      {/* Input Field */}
      <input
        ref={inputRef}
        onFocus={() => setShowDropdown(true)}
        onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
        placeholder="Select test"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{  padding: "6px", border: "1px solid #ccc" }}
      />

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, m: 1 }}>
        {(selectedTests || []).map((serviceName, idx) => (
          <Chip
            key={idx}
            label={serviceName}
            onDelete={() => onDeleteTest && onDeleteTest(serviceName)}
            color="primary"
            variant="outlined"
          />
        ))}
      </Box>

      {/* Dropdown */}
      {showDropdown && filteredList.length > 0 && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "#fff",
            border: "1px solid #ccc",
            zIndex: 10,
            maxHeight: 200,
            overflowY: "auto",
            margin: 0,
            padding: 0,
            listStyle: "none",
          }}
        >
          {filteredList.map((test, idx) => (
            <li
              key={test.id || idx}
              style={{ padding: "8px", cursor: "pointer" }}
              onMouseDown={() => handleSelect(test.service_name)}
            >
              {test.service_name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default TestDropdown;
